const FullNews = ({ img, mobImg, title, link, position }) => {
  const formats = img?.data?.attributes?.formats
  return (
    <a className="relative" href={link}>
      <div className="absolute w-full bottom-0 bg-gradient-to-t from-blue via-blue">
        <h1 className="font-alliance-medium tracking-tight text-white text-2xl mx-4 mt-32 mb-10 lg:mb-24 sm:text-5xl md:text-6xl lg:text-5xl xl:text-6xl lg:mr-24">
          {title}
        </h1>
      </div>
      <picture>
        <source
          media="(orientation: landscape)"
          srcSet={formats?.xlarge?.url}
        />
        <source
          media="(orientation: portrait)"
          srcSet={
            mobImg?.data?.attributes?.formats?.large?.url || formats?.large?.url
          }
        />
        <img
          src={
            formats?.xlarge?.url || formats?.large?.url || formats?.medium?.url
          }
          className={`object-${position || 'center'}`}
        />
      </picture>
    </a>
  )
}

export default FullNews
